import posthog from 'posthog-js'

export default function({ env, app, store }, inject) {
  // Init PostHog
  posthog.init(env.POSTHOG_API_KEY, {
    api_host: env.POSTHOG_API_HOST,
    autocapture: true,
    capture_pageview: 'history_change',
    capture_pageleave: true,
    persistence: 'localStorage+cookie'
  })

  // Wrap the capture method to apply redaction logic for all events
  // Store reference is captured in closure - will be accessed at runtime when capture is called
  const originalCapture = posthog.capture.bind(posthog)
  posthog.capture = function(eventName, properties = {}) {
    // Don't redact PostHog's internal identify events
    // These events are used to set person properties and should not be redacted
    if (eventName === '$identify' || eventName === '$identify_feature_flags') {
      return originalCapture(eventName, properties)
    }

    // Get search_log_encryption from store at runtime (when capture is actually called)
    // By this time, the store should be populated with userSubscriptions data
    // Try multiple ways to access the store to ensure we can get it
    let currentStore = store

    // On client side, try to get store from app context if available
    if (typeof window !== 'undefined') {
      if (app && app.$store) {
        currentStore = app.$store
      } else if (app && app.store) {
        currentStore = app.store
      }
    }

    const features = currentStore?.state?.userSubscriptions?.features
    const hasSearchLogEncryption = !!features?.search_log_encryption

    let propertiesToUse = JSON.parse(JSON.stringify(properties))
    if (hasSearchLogEncryption && properties) {
      propertiesToUse = {}
      for (const [key, value] of Object.entries(properties)) {
        if (key.startsWith('$')) {
          propertiesToUse[key] = value
        } else {
          propertiesToUse[key] = '-REDACTED-'
        }
      }
    }

    // Call the original capture method with redacted properties
    return originalCapture(eventName, propertiesToUse)
  }

  // Inject PostHog into the application and make it available via this.$posthog (or app.$posthog)
  inject('posthog', posthog)
}
